// Ensure CartPerformance is available or create a fallback
if (typeof CartPerformance === 'undefined') {
  window.CartPerformance = {
    createStartingMarker: () => null,
    measureFromEvent: () => {},
    measureFromMarker: () => {},
    measure: (name, callback) => callback()
  };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        console.log('ProductForm connected for section:', this.dataset.sectionId || 'unknown');

        this.form = this.querySelector('form');
        if (!this.form) {
          console.error('ProductForm: form element not found inside <product-form>');
          return;
        }
        const variantInput = this.form.querySelector('[name="id"]');
        if (variantInput) {
          variantInput.disabled = false;
        } else {
          console.warn('ProductForm: variant id input [name="id"] not found');
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        console.log('Cart element detected:', this.cart ? this.cart.tagName : 'None');

        // If cart drawer not found initially, try again after DOM is fully loaded
        if (!this.cart) {
          console.log('Cart not found initially, retrying...');
          setTimeout(() => {
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            console.log('Cart element detected on retry:', this.cart ? this.cart.tagName : 'None');
          }, 100);
        }
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        console.log('ProductForm onSubmitHandler called');
        evt.preventDefault();
        // Block submission for display-only examples (e.g., personalisation examples)
        try {
          if (this.form && this.form.dataset && this.form.dataset.displayOnly === 'true') {
            this.handleErrorMessage('This is a display-only example and cannot be purchased.');
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            return;
          }
        } catch (_) { /* no-op */ }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const stockNumberValue = this.getStockNumberValue();
        formData.delete('properties[Stock Number]');
        if (stockNumberValue) {
          formData.set('properties[Stock Number]', stockNumberValue);
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Try to find cart drawer one more time before deciding behavior
              this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              console.log('Final cart detection attempt:', this.cart ? this.cart.tagName : 'None');

              if (!this.cart) {
                // Do NOT redirect; gracefully remain on page
                console.warn('No cart drawer found; staying on page after add.');
              }
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            if (typeof window.__wl_queueServiceAdd === 'function') {
              try {
                window.__wl_queueServiceAdd(response, 'product-form');
              } catch (serviceErr) {
                console.warn('Service add queue failed:', serviceErr);
              }
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              console.log('Rendering cart contents with response:', response);
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });

              // Fallback: manually open cart drawer if it doesn't open automatically
              setTimeout(() => {
                if (this.cart && this.cart.tagName === 'CART-DRAWER' && !this.cart.classList.contains('active')) {
                  console.log('Manually opening cart drawer');
                  this.cart.open();
                }
              }, 100);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      getStockNumberValue() {
        const stockInput = this.form.querySelector('[data-stock-number-input]');
        if (stockInput && typeof stockInput.value === 'string') {
          const trimmed = stockInput.value.trim();
          if (trimmed !== '') {
            return trimmed;
          }
        }

        let lookupRoot = null;
        if (this.dataset.sectionId) {
          lookupRoot = document.querySelector(`#shopify-section-${this.dataset.sectionId} [data-product-sku-wrapper]`);
        }
        if (!lookupRoot) {
          lookupRoot = document.querySelector('[data-product-sku-wrapper]');
        }

        if (lookupRoot && lookupRoot.dataset) {
          const dataset = lookupRoot.dataset;
          const fallback = (dataset.stockNumber || dataset.defaultStockNumber || '').trim();
          if (fallback !== '') {
            return fallback;
          }
        }

        return '';
      }
    }
  );
}
